import { InviteFormFields, InviteFormValues, Peo } from './types';

export const PEO_INITIAL_VALUES: Peo = {
  email: '',
  isRevenueShareEnabled: false,
};

export const INITIAL_VALUES: InviteFormValues = {
  [InviteFormFields.peoPayrollProvider]: null,
  [InviteFormFields.peos]: [PEO_INITIAL_VALUES],
};
